<template>
  <div class="app">
    <secondHeader />
    <div class="main">
      <sidebar />
      <main class="tool-content">
        <!-- Hero Section -->
        <section class="tool-hero">
          <div class="tool-hero-content">
            <h1>配信活動者のためのツール集</h1>
          </div>
        </section>

        <!-- Tools Section -->
        <section class="tool-tools-section">
          <div class="tool-container">
            <div class="tool-tools-grid">
              <div v-for="toolKit in toolKits" :key="toolKit.index" class="tool-card-wrapper">
                <router-link v-if="toolKit.type === 'internal'" :to="toolKit.to" class="tool-link">
                  <div class="tool-card">
                    <div class="tool-image">
                      <img :src="toolKit.src" :alt="toolKit.title" />
                    </div>
                    <div class="tool-card-content">
                      <h3>{{ toolKit.title }}</h3>
                      <p>{{ toolKit.description }}</p>
                    </div>
                  </div>
                </router-link>
                <a v-else :href="toolKit.to" target="_blank" rel="noopener noreferrer" class="tool-link">
                  <div class="tool-card">
                    <div class="tool-image">
                      <img :src="toolKit.src" :alt="toolKit.title" />
                    </div>
                    <div class="tool-card-content">
                      <h3>{{ toolKit.title }}</h3>
                      <p>{{ toolKit.description }}</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>

        <!-- Tests Section -->
        <section class="tool-tests-section">
          <div class="tool-container">
            <h2 class="tool-section-title">その他のコンテンツ</h2>
            <div class="tool-tests-list">
              <router-link to="/reaction-test" class="tool-test-item">
                <span class="tool-test-name">反射神経テスト</span>
                <span class="tool-test-desc">反射神経を測定してランクを確認</span>
              </router-link>
              <router-link to="/click-test" class="tool-test-item">
                <span class="tool-test-name">クリック数テスト</span>
                <span class="tool-test-desc">制限時間内の連打速度を測定</span>
              </router-link>
              <router-link to="/circle-test" class="tool-test-item">
                <span class="tool-test-name">まんまるテスト</span>
                <span class="tool-test-desc">正確な円を描いてみよう</span>
              </router-link>
            </div>
          </div>
        </section>

        <!-- Services Section -->
        <section class="tool-services-section">
          <div class="tool-container">
            <h2 class="tool-section-title">関連サービス</h2>
            <div class="tool-service-banners">
              <a href="https://short-v.net/" target="_blank" rel="noopener noreferrer" class="tool-service-banner-link">
                <img src="@/assets/shortv-banner.png" alt="Short分析V" class="tool-service-banner"/>
              </a>
              <a href="https://hari-stream.com/" target="_blank" rel="noopener noreferrer" class="tool-service-banner-link">
                <img src="@/assets/hari-banner.png" alt="おたより募集ツールHARI" class="tool-service-banner"/>
              </a>
            </div>
            
            <!-- Featured Service -->
            <div class="tool-featured-service">
              <div class="tool-featured-content">
                <div class="tool-featured-text">
                  <span class="tool-featured-badge">＼イチオシ！／</span>
                  <h3>おたよりサービスHARI</h3>
                  <p>配信者のためのおたより募集サービスです。<br>テーマ別の募集やOBSとの連携機能で、効率的に配信の用意をできます。</p>
                  <a href="https://hari-stream.com/" target="_blank" rel="noopener noreferrer" class="tool-cta-button">詳しくはこちら</a>
                </div>
                <div class="tool-featured-media">
                  <video controls class="tool-featured-video">
                    <source src="@/assets/videos/hariweb.mp4" type="video/mp4">
                    お使いのブラウザは動画タグに対応していません。
                  </video>
                </div>
              </div>
            </div>
          </div>
        </section>
                <!-- Updates Section -->
        <section class="tool-updates-section">
          <div class="tool-container">
            <div class="tool-updates-header">
              <h3 class="tool-updates-title">最新の更新</h3>
              <router-link to="/news" class="tool-view-all-link">すべて見る</router-link>
            </div>
            <div class="tool-updates-grid">
              <div 
                v-for="(update, index) in displayUpdates" 
                :key="update.id"
                class="tool-update-card"
                :class="{ featured: index === 0 }"
              >
                <div v-if="update.isNew" class="tool-update-badge">NEW</div>
                <div class="tool-update-content">
                  <div class="tool-update-date">{{ update.date }}</div>
                  <h4 class="tool-update-title">{{ update.title }}</h4>
                  <p class="tool-update-desc">{{ update.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Ad Section -->
        <section class="tool-ad-section">
          <div class="tool-container">
            <InFeedAdsense
              data-ad-layout-key="-fb+5w+4e-db+86"
              data-ad-client="ca-pub-9016794589237931"
              data-ad-slot="4898735474">
            </InFeedAdsense>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>
<script>
import secondHeader from "../components/secondHeader.vue";
import sidebar from "../components/sidebar.vue"
import { getRecentUpdates } from '@/utils/updateDataManager.js';

export default {
  components: {
    secondHeader,
    sidebar,
  },
  computed: {
    displayUpdates() {
      return getRecentUpdates(3); // 最新3件を表示
    }
  },
  data() {
    return {
      toolKits: [
        {
          index: 1,
          type: "internal",
          src: require("@/assets/carousel/gradation_clock.png"),
          to: "/clockcreate",
          title: "配信用デジタル時計",
          description:
            "カスタマイズ可能な時計を複数用意。自由なコンセプトを実現できます。",
        },
        {
          index: 2,
          type: "internal",
          src: require("@/assets/carousel/fukidashi.png"),
          to: "/ytcomment",
          title: "YouTube・Twitchコメント欄",
          description:
            "YouTubeLIVE・Twitchのコメント欄を簡単にカスタマイズ。複数のデザインから選べます。",
        },
        {
          index: 3,
          type: "internal",
          src: require("@/assets/thumbnail/discordroom.png"),
          to: "/discordroom",
          title: "DiscordオーバレイCSS",
          description:
            "Discordのオーバレイをカスタマイズ。オリジナルのアニメーションを用意しています。",
        },
        {
          index: 4,
          type: "internal",
          src: require("@/assets/thumbnail/timer-preview.png"),
          to: "/timer",
          title: "タイマー",
          description:
            "配信画面に載せれるシンプルタイマー。同時視聴をするときに便利です。",
        },
        {
          index: 5,
          type: "internal",
          src: require("@/assets/thumbnail/counter-thumbnail.png"),
          to: "/multicounter",
          title: "カウンター",
          description: "ラベルと単位を個別に設定できるカウンター",
        },
        {
          index: 6,
          type: "internal",
          src: require("@/assets/thumbnail/roulette.png"),
          to: "/roulette",
          title: "ルーレット",
          description: "軽量なルーレットアプリです。",
        },
        {
          index: 7,
          type: "external",
          src: require("@/assets/thumbnail/setolisan-thomnail.png"),
          to: "https://takatsukisyou.booth.pm/items/5826705",
          title: "セトリサン",
          description: "セットリスト管理ツール。配信画面に今歌っている曲をきれいに表示。",
        },
        {
          index: 8,
          type: "internal",
          src: require("@/assets/thumbnail/bgcreate.png"),
          to: "/bgcreate",
          title: "背景生成ツール",
          description: "自由自在に背景を生成できるツールです。",
        },
      ],
    };
  },
};
</script>
<style scoped>
/* Reset & Base */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Layout */
.app {
  min-height: 100vh;
}

.main {
  display: flex;
  min-height: 100vh;
}

.tool-content {
  flex: 1;
  background: #fafafa;
  padding: 0 16px;
  overflow-x: hidden;
}

/* Container */
.tool-container {
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Updates Section */
.tool-updates-section {
  background: white;
  padding: 32px 0;
  border-bottom: 1px solid #e2e8f0;
}

.tool-updates-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.tool-updates-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.tool-view-all-link {
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748b;
  text-decoration: none;
  transition: color 0.2s ease;
}

.tool-view-all-link:hover {
  color: #0f172a;
}

.tool-updates-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 16px;
}

.tool-update-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  position: relative;
  transition: all 0.2s ease;
}

.tool-update-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.tool-update-card.featured {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-color: #cbd5e1;
}

.tool-update-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: #0f172a;
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 4px;
  letter-spacing: 0.5px;
}

.tool-update-content {
  width: 100%;
}

.tool-update-date {
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

.tool-update-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 8px 0;
  line-height: 1.4;
}

.tool-update-desc {
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.4;
  margin: 0;
}

.tool-update-card.featured .tool-update-title {
  font-size: 1rem;
}

.tool-update-card.featured .tool-update-desc {
  font-size: 0.875rem;
}

/* Hero Section */
.tool-hero {
  background: white;
  padding: 32px 0 0 0;
  margin-top: 48px;
}

.tool-hero-content {
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;
}
.tool-hero h1 {
  font-size: 1.8rem;
  font-weight: 600;
  color: #0f172a;
}

/* Section Styles */
section {
  padding: 64px 0;
}

.tool-section-title {
  font-size: 1.875rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 32px;
  text-align: center;
  letter-spacing: -0.025em;
}

/* Tools Section */
.tool-tools-section {
  background: white;
}

.tool-tools-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 20px;
}

.tool-card-wrapper {
  width: 100%;
}

.tool-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

.tool-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  transition: all 0.2s ease;
  height: 100%;
  min-height: 160px;
}

.tool-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border-color: #cbd5e1;
}

.tool-image {
  flex-shrink: 0;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border-radius: 12px;
  overflow: hidden;
}

.tool-image img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
}

.tool-card-content {
  flex: 1;
}

.tool-card-content h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
  line-height: 1.4;
}

.tool-card-content p {
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.5;
}

/* Tests Section */
.tool-tests-section {
  background: #f8fafc;
}

.tool-tests-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 600px;
  margin: 0 auto;
}

.tool-test-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  text-decoration: none;
  color: inherit;
  transition: all 0.2s ease;
}

.tool-test-item:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.tool-test-name {
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
}

.tool-test-desc {
  font-size: 0.875rem;
  color: #64748b;
  text-align: right;
}

/* Services Section */
.tool-services-section {
  background: white;
}

.tool-service-banners {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 48px;
}

.tool-service-banner-link {
  display: block;
  transition: transform 0.2s ease;
}

.tool-service-banner-link:hover {
  transform: translateY(-2px);
}

.tool-service-banner {
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

/* Featured Service */
.tool-featured-service {
  background: #f8fafc;
  border-radius: 16px;
  padding: 32px;
  margin-top: 32px;
}

.tool-featured-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: center;
}

.tool-featured-badge {
  display: inline-block;
  background: #0f172a;
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 16px;
  margin-bottom: 16px;
}

.tool-featured-text h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 16px;
}

.tool-featured-text p {
  font-size: 1rem;
  color: #64748b;
  line-height: 1.6;
  margin-bottom: 24px;
}

.tool-cta-button {
  display: inline-block;
  background: #0f172a;
  color: white;
  text-decoration: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.875rem;
  transition: background-color 0.2s ease;
}

.tool-cta-button:hover {
  background: #1e293b;
}

.tool-featured-video {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

/* Ad Section */
.tool-ad-section {
  background: #f8fafc;
  text-align: center;
}

/* Responsive */
@media (max-width: 1024px) {
  .tool-updates-grid {
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
  
  .tool-update-card.featured {
    grid-column: 1 / -1;
  }
  
  .tool-tools-grid {
    grid-template-columns: 1fr;
  }
  
  .tool-featured-content {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}

@media (max-width: 768px) {
  .tool-updates-section {
    padding: 24px 0;
  }
  
  .tool-updates-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .tool-update-card.featured {
    grid-column: 1;
  }
  
  .tool-update-card {
    padding: 16px;
  }
  
  .tool-update-badge {
    top: 8px;
    right: 8px;
    font-size: 0.7rem;
    padding: 3px 6px;
  }
  
  .tool-hero h1 {
    font-size: 2rem;
  }
  
  .tool-hero-description {
    font-size: 1rem;
  }
  
  .tool-container {
    padding: 0 16px;
  }
  
  .tool-content {
    padding: 0 8px;
  }
  
  section {
    padding: 32px 0;
  }
  
  .tool-tools-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .tool-card {
    flex-direction: row;
    align-items: center;
    gap: 16px;
    padding: 20px;
  }
  
  .tool-image {
    width: 100px;
    height: 100px;
    flex-shrink: 0;
  }
  
  .tool-image img {
    width: 80px;
    height: 80px;
  }
  
  .tool-tests-list {
    gap: 8px;
  }
  
  .tool-test-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    padding: 14px 16px;
  }
  
  .tool-test-desc {
    text-align: left;
  }
  
  .tool-service-banners {
    grid-template-columns: 1fr;
  }
  
  .tool-featured-service {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .tool-updates-section {
    padding: 20px 0;
  }
  
  .tool-updates-header {
    margin-bottom: 16px;
  }
  
  .tool-updates-title {
    font-size: 1.1rem;
  }
  
  .tool-view-all-link {
    font-size: 0.8rem;
  }
  
  .tool-update-card {
    padding: 14px;
  }
  
  .tool-update-title {
    font-size: 0.85rem;
  }
  
  .tool-update-desc {
    font-size: 0.75rem;
  }
  
  .tool-update-card.featured .tool-update-title {
    font-size: 0.9rem;
  }
  
  .tool-update-card.featured .tool-update-desc {
    font-size: 0.8rem;
  }
  
  .tool-hero {
    padding: 24px 0;
  }
  
  .tool-hero h1 {
    font-size: 1.75rem;
  }
  
  .tool-container {
    padding: 0 12px;
  }
  
  .tool-content {
    padding: 0 4px;
  }
  
  .tool-card {
    flex-direction: column;
    text-align: center;
    gap: 12px;
    padding: 16px;
  }
  
  .tool-image {
    width: 80px;
    height: 80px;
    margin: 0 auto;
  }
  
  .tool-image img {
    width: 64px;
    height: 64px;
  }
  
  .tool-test-item {
    padding: 12px 14px;
    gap: 2px;
  }
  
  .tool-test-name {
    font-size: 0.9rem;
  }
  
  .tool-test-desc {
    font-size: 0.8rem;
  }
}
</style>
